/*
 * File: Api.ts
 * Project: mp-mobile-app
 *
 * Created by Cole on 01/02/2020
 *
 * Copyright (c) 2021 MacPractice, Inc. All rights reserved.
 *
 * Description: Makes API requests for the clinical views.
 */
import { Http } from "api/Http";
import { AxiosResponse } from "axios";
import { SnapshotIn } from "mobx-state-tree";
import { ClinicalPreferenceValue } from "services/preferences/models/ClinicalPreferenceValue";

export type ClinicalCountsResult = {
  [key: string]: { count: number; privilege: boolean };
};

export type ClinicalOptionsResult = {
  desktop: SnapshotIn<typeof ClinicalPreferenceValue>[];
  default: SnapshotIn<typeof ClinicalPreferenceValue>[];
};

class ClinicalApi {
  patientApi = new Http("patients/1/patient");
  preferencesApi = new Http("preferences/1/preferences");

  getClinicalCounts = async (patientId: number) => {
    const res: AxiosResponse<ClinicalCountsResult> = await this.patientApi.get(
      "/",
      patientId + "/clinicalCounts"
    );
    return res.data || [];
  };

  getClinicalOptions = async () => {
    const res: AxiosResponse<ClinicalOptionsResult> = await this.preferencesApi.get(
      "/clinicalOptions"
    );

    return res.data;
  };
}

const newApi = new ClinicalApi();
export default newApi;
